// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"da24d956","181":"6479fdbb","238":"cf9b1d9f","453":"ba850176"}[chunkId] + ".chunk.js";
};